export const selectMenu = state => state.subMenuReducer;
